import revive_payload_client_4sVQNw7RlN from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_immediate_client_xfI97IMoyr from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/app/plugins/chunk-reload-immediate.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/atlassian/pipelines/agent/build/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_Jozdw60ZsE from "/opt/atlassian/pipelines/agent/build/node_modules/dayjs-nuxt/dist/runtime/plugin.js";
import plugin_U4BUIcs89R from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt-graphql-client/dist/runtime/plugin.js";
import switch_locale_path_ssr_5csfIgkrBP from "/opt/atlassian/pipelines/agent/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/opt/atlassian/pipelines/agent/build/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import nuxt_plugin_6wEQMY3tee from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import activity_client_G378hh7ViS from "/opt/atlassian/pipelines/agent/build/plugins/activity.client.ts";
import dayjs_locale_L2gWnTLlLe from "/opt/atlassian/pipelines/agent/build/plugins/dayjs-locale.ts";
import ga_client_7dQ7yMojeg from "/opt/atlassian/pipelines/agent/build/plugins/ga.client.ts";
import gql_interceptor_UORmbZjQ17 from "/opt/atlassian/pipelines/agent/build/plugins/gql-interceptor.ts";
import gtag_client_Zw8EQXNVTz from "/opt/atlassian/pipelines/agent/build/plugins/gtag.client.ts";
import gtm_client_OzmBuHLRIb from "/opt/atlassian/pipelines/agent/build/plugins/gtm.client.ts";
import handshake_client_TjNtUigTch from "/opt/atlassian/pipelines/agent/build/plugins/handshake.client.ts";
import interceptor_3QMGQCykd6 from "/opt/atlassian/pipelines/agent/build/plugins/interceptor.ts";
import locale_client_ahjD9sRyPo from "/opt/atlassian/pipelines/agent/build/plugins/locale.client.ts";
import osano_client_nJ1HAvJY74 from "/opt/atlassian/pipelines/agent/build/plugins/osano.client.ts";
import pp_client_vCXO84IlaJ from "/opt/atlassian/pipelines/agent/build/plugins/pp.client.ts";
import sentry_client_shVUlIjFLk from "/opt/atlassian/pipelines/agent/build/plugins/sentry.client.ts";
import yup_OM8D6DMeq7 from "/opt/atlassian/pipelines/agent/build/plugins/yup.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_immediate_client_xfI97IMoyr,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_Jozdw60ZsE,
  plugin_U4BUIcs89R,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  nuxt_plugin_6wEQMY3tee,
  activity_client_G378hh7ViS,
  dayjs_locale_L2gWnTLlLe,
  ga_client_7dQ7yMojeg,
  gql_interceptor_UORmbZjQ17,
  gtag_client_Zw8EQXNVTz,
  gtm_client_OzmBuHLRIb,
  handshake_client_TjNtUigTch,
  interceptor_3QMGQCykd6,
  locale_client_ahjD9sRyPo,
  osano_client_nJ1HAvJY74,
  pp_client_vCXO84IlaJ,
  sentry_client_shVUlIjFLk,
  yup_OM8D6DMeq7
]